import ComponentStructure from '../basic'

export default class I18nForLwButtonGroup extends ComponentStructure {
  name = 'lw-button-group'
  properties = []

  getHtmlElement () {
    return null
  }

  getPropertyShownElement (property: string) {
    return null
  }

  getChildComponents () {
    return this.component.components || []
  }
}
